import * as React from 'react'
import clsx from 'clsx'

import styles from './FramedImage.module.css'

export type FramedImageProps = {
  src: string
  alt: string
  /** Sets the frame footprint (width / aspect-ratio) from the caller. */
  className?: string
}

/**
 * A tilted "framed print": the image fills an ink-bordered, rounded, sticker-shadowed card via
 * object-fit: cover (so no white mat shows — give the frame the photo's aspect so nothing is cropped).
 * Straightens on hover.
 */
export function FramedImage({ src, alt, className }: FramedImageProps): React.ReactElement {
  return (
    <div className={clsx(styles.frame, className)}>
      <div className={styles.frame__card}>
        <img className={styles.frame__image} src={src} alt={alt} loading="lazy" decoding="async" />
      </div>
    </div>
  )
}
